import './accommodation-content.scss'
import _ from 'lodash'
import anime from 'animejs'
import { loadSvg } from 'js/utility/image.js'

export const component = {
    name: 'accommodation-content',

    data: {
        accommodation: {},
        gallery: null,
        filters: {
            beds: null,
            bedrooms: null,
            service: null,
            bathrooms: null,
            area: null,
            kitchenette: null
        },
        map: null,
        order: 'desc',
        orderBy: 'beds',
        rooms: [],
        readMore: false,
        readMoreDisplay: false
    },

    computed: {
        filteredRooms () {
            let rooms = this.rooms
            _.each(this.filters, (filterValue, filter) => {
                rooms = _.filter(rooms, room => {
                    if (filter === 'beds') {
                        if (!filterValue) {
                            return true
                        } else if (filterValue < 5) {
                            return room.beds >= filterValue
                        } else {
                            return room.beds >= 5
                        }
                    } else if (filter === 'bedrooms') {
                        if (!filterValue) {
                            return true
                        } else if (filterValue < 5) {
                            return room.bed_rooms === filterValue
                        } else {
                            return room.bed_rooms >= 5
                        }
                    } else if (filter === 'service') {
                        if (!filterValue) {
                            return true
                        } else {
                            return _.findIndex(room.services, service => service.slug === filterValue) >= 0
                        }
                    } else if (filter === 'bathrooms') {
                        if (!filterValue) {
                            return true
                        } else {
                            return room.bathrooms === filterValue
                        }
                    } else if (filter === 'area') {
                        if (!filterValue) {
                            return true
                        } else {
                            if (filterValue === 1) {
                                return room.area < 40
                            } else if (filterValue === 2) {
                                return _.inRange(room.area, 40, 61)
                            } else if (filterValue === 3) {
                                return room.area > 60
                            }
                        }
                    } else if (filter === 'kitchenette') {
                        if (!filterValue) {
                            return true
                        } else {
                            const hasService = !!_.find(room.services, service => (service.name === 'Angolo Cottura') || (service.name === 'Kitchenette'))
                            if (filterValue === 1) {
                                return hasService
                            } else if (filterValue === 2) {
                                return !hasService
                            }
                        }
                    }
                })
            })
            return rooms
        },

        roomsList () {
            switch (this.orderBy) {
                case 'beds':
                    return _.orderBy(this.filteredRooms, 'beds', this.order)
                    break
                case 'offers':
                    return _.orderBy(this.filteredRooms, (room) => this.offerActive(room), this.order)
                    break
                case 'type':
                    return _.orderBy(this.filteredRooms, 'type', this.order)
                    break
                case 'area':
                    return _.orderBy(this.filteredRooms, 'area', this.order)
                    break
                case 'bathrooms':
                    return _.orderBy(this.filteredRooms, 'bathrooms', this.order)
                    break
            }
        }
    },

    mounted () {
        this.googleMap()

        // service icons
        _.each(this.accommodation.services, service => {
            if (service.image_url) {
                Promise.resolve()
                    .then(() => loadSvg(service.image_url))
                    .then(svg => { service.icon = svg.outerHTML })
            }
        })

        // lightbox
        this.gallery = new LuminousGallery(this.$el.querySelectorAll('.accommodation-content__image'))

        _.defer(() => {
            if (this.$refs.innerContent.offsetHeight <= this.$refs.content.offsetHeight) {
                this.readMore = true
            } else {
                this.readMoreDisplay = true
            }
        })
    },

    methods: {
        googleMap () {
            if ( !window.google ) {
                setTimeout(() => this.googleMap(), 1000)
                return
            }
            const position = {
                lat: parseFloat(this.accommodation.position.lat),
                lng: parseFloat(this.accommodation.position.lng)
            }

            this.map = new google.maps.Map(this.$refs.map, {
                center: position,
                zoom: 16
            })

            new google.maps.Marker({
                position,
                map: this.map
            })
        },

        offerActive (room) {
            if (room.offer) {
                const offerFromExploded = room.offer_from.split('/')
                const offerToExploded = room.offer_to.split('/')
                const offerFrom = new Date(`${offerFromExploded[2]}-${offerFromExploded[1]}-${offerFromExploded[0]}T00:00:00`)
                const offerTo = new Date(`${offerToExploded[2]}-${offerToExploded[1]}-${offerToExploded[0]}T24:00:00`)
                const now = new Date()
                return offerFrom <= now && now <= offerTo
            } else {
                return false
            }
        },

        resetFilters () {
            this.filters.beds = null
            this.filters.bedrooms = null
            this.filters.service = null
            this.filters.bathrooms = null
            this.filters.area = null
            this.filters.kitchenette = null
        },

        scrollTo (section) {
            let el = null
            switch (section) {
                case 'rooms':
                    el = this.$refs.roomsSection
                    break
                case 'services':
                    el = this.$refs.servicesSection
                    break
                case 'map':
                    el = this.$refs.mapSection
                    break
            }
            const top = el.getBoundingClientRect().top
            const obj = { top: window.pageYOffset }
            anime({
                targets: obj,
                top: [window.pageYOffset, window.pageYOffset + top - 24],
                duration: 500,
                easing: 'easeInOutSine',
                update: () => {
                    window.requestAnimationFrame(() => {
                        window.scrollTo(0, obj.top)
                    })
                }
            })
        },

        toggleFilter(filter, filterValue) {
            if (this.filters[filter] && this.filters[filter] === filterValue) {
                this.filters = _.assign(this.filters, { [filter]: null })
            } else {
                this.filters = _.assign(this.filters, { [filter]: filterValue })
            }
        },

        toggleOrder(orderBy) {
            if (orderBy === this.orderBy) {
                if (this.order === 'asc') {
                    this.order = 'desc'
                } else {
                    this.order = 'asc'
                }
            } else {
                this.orderBy = orderBy
            }
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/accommodation-content/accommodation-content.js